import { render, staticRenderFns } from "./SipremWeb.vue?vue&type=template&id=36a33015&"
import script from "./SipremWeb.vue?vue&type=script&lang=js&"
export * from "./SipremWeb.vue?vue&type=script&lang=js&"
import style0 from "./SipremWeb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports